import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../../actions'
import VerifyPhoneCode from '../../VerifyPhoneCode'

import './VerifyOneTimeCode.css'
import { eventTypes, event } from '../../../../consts/eventConsts'

const VerifyOneTimeCode = () => {
  const dispatch = useDispatch()
  const isOneTimeCodeVerificationLoading = useSelector(
    state => state.auth?.isOneTimeCodeVerificationLoading
  )
  const phoneNumber = useSelector(state => state.auth?.phoneNumber)

  const handleResend = phoneNumber => {
    dispatch(
      Actions.createAction(Actions.LOGIN_PHONE_NUMBER_REQUESTED, {
        phoneNumber,
      })
    )
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.formEvent,
        eventName: event.formEvent.submit,
        data: { phoneNumber },
        element: 'next send again telehealth',
      })
    )
  }

  const handleNext = ({ phoneNumber, code }) => {
    dispatch(
      Actions.createAction(Actions.ONE_TIME_SMS_LOGIN_CODE_VERIFY_REQUESTED, {
        phoneNumber,
        value: code,
      })
    )
  }

  return (
    <VerifyPhoneCode
      onNext={({ phoneNumber, code }) => handleNext({ phoneNumber, code })}
      onResend={phone => handleResend(phone)}
      phone={phoneNumber}
      loading={isOneTimeCodeVerificationLoading}
    />
  )
}

export default VerifyOneTimeCode
